module.exports = __webpack_public_path__ + "static/img/ranking_center_l.7956c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_center_l.png
// module id = j9fa
// module chunks = 0